module.exports = __webpack_public_path__ + "img/header-engagementRingsDiamonds.31cb48b.jpg";